var Backbone, SharedFooterIntlPhoneNumberView, SharedIntlCallUsTemplate, SharedTicketNumberMsgTemplate,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedTicketNumberMsgTemplate = require('../../../../ticket_number_msg.html.mustache');

SharedIntlCallUsTemplate = require('../../../../intl_call_us.html.mustache');

SharedFooterIntlPhoneNumberView = (function(superClass) {
  extend(SharedFooterIntlPhoneNumberView, superClass);

  function SharedFooterIntlPhoneNumberView() {
    this.renderError = bind(this.renderError, this);
    this.renderSuccess = bind(this.renderSuccess, this);
    return SharedFooterIntlPhoneNumberView.__super__.constructor.apply(this, arguments);
  }

  SharedFooterIntlPhoneNumberView.prototype["class"] = 'support';

  SharedFooterIntlPhoneNumberView.prototype.initialize = function(options) {
    this.options = options || {};
    this.I18nScope = 'modules.support';
    this.template = SharedIntlCallUsTemplate;
    this.ticketNumberMsgTemplate = SharedTicketNumberMsgTemplate;
    this.popupContainer = $("#popup");
    this.emailFormModel = this.options.emailFormModel;
    return this.shouldRenderPopup = this.options.renderPopup;
  };

  SharedFooterIntlPhoneNumberView.prototype.render = function() {
    var data, ref;
    if (this.shouldRenderPopup) {
      this.renderPopup();
    } else {
      this.renderPhoneNumber();
    }
    if (((ref = window.experiments) != null ? ref.callTicketEnabled : void 0) && window.isLoggedIn) {
      data = this.emailFormModel.getBasicTicketData();
      data.synchronous = true;
      createTicket(data, this.renderSuccess, this.renderError, this.$el.find('#ticket-number-msg'), "100px");
      return propagateEventBeforeReplacingElements(function() {
        return $('#g-spinner').addClass('call-us-popup-spinner');
      });
    }
  };

  SharedFooterIntlPhoneNumberView.prototype.renderSuccess = function(response) {
    var ref, ticketNumber;
    ticketNumber = response != null ? (ref = response.res) != null ? ref.ticket_id : void 0 : void 0;
    if (ticketNumber != null) {
      return this.$el.find('#ticket-number-msg').html(toHtml(this.ticketNumberMsgTemplate, this.getTicketSuccessHash(ticketNumber), this.I18nScope));
    } else {
      return this.renderError();
    }
  };

  SharedFooterIntlPhoneNumberView.prototype.renderError = function() {
    return this.$el.find('#ticket-number-msg').html("");
  };

  SharedFooterIntlPhoneNumberView.prototype.renderPopup = function() {
    GIG.Modal.open({
      el: this.popupContainer,
      closeOnBgClick: true,
      closeOnEscKey: true
    });
    this.renderPhoneNumber();
    return this.popupContainer.html(this.el);
  };

  SharedFooterIntlPhoneNumberView.prototype.renderPhoneNumber = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SharedFooterIntlPhoneNumberView.prototype.toHash = function() {
    return {
      call_us_message: getCallUsMsg(),
      shouldRenderPopup: this.shouldRenderPopup
    };
  };

  SharedFooterIntlPhoneNumberView.prototype.getTicketSuccessHash = function(ticketNumber) {
    return _.extend({
      ticket_number: ticketNumber
    }, window.getOrderInfoForBH(Groupon.Support.currentOrder));
  };

  SharedFooterIntlPhoneNumberView.prototype.closeModal = function() {
    GIG.Modal.close();
    return false;
  };

  SharedFooterIntlPhoneNumberView.prototype.events = {
    'click .close-modal': "closeModal",
    'click .b-close': "closeModal"
  };

  return SharedFooterIntlPhoneNumberView;

})(Backbone.View);

module.exports = SharedFooterIntlPhoneNumberView;

//# sourceMappingURL=data:application/json;base64,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
